export class GeneralError extends Error {
  public constructor(msg?: string) {
    super()

    this.message = msg ? `errors.${msg}` : 'errors.general'
  }
}
